module.exports = function (url) {
  const path = new URL(url);
  const pathname = path.pathname;
  if (window.ga && ga.loaded) {
    ga('send', 'pageview', pathname);
  }
};
